import React from 'react'
import { FooterLayout } from './layout'
import { FooterState } from './state'
import { any, async, fromJSX, StandardLocalWidget } from 'widgets-for-react'

export const footerWidget =
  (refrescoBranding: boolean): StandardLocalWidget<FooterState> =>
  (state) =>
    any([
      async(state.menu).map(
        (updater) =>
          (state): FooterState => ({ ...state, menu: updater(state.menu) })
      ),
      async(state.privacyMenu).map(
        (updater) =>
          (state): FooterState => ({ ...state, privacyMenu: updater(state.privacyMenu) })
      ),
      fromJSX(() => <FooterLayout {...state} refrescoBranding={refrescoBranding} />)
    ])
